<template>
  <div>
    <!-- 查询搜索 -->
    <div class="search">
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
        size="small"
      >
        <el-row
          :gutter="20"
          v-for="(group, groupIndex) in groupedSearchColumns"
          :key="groupIndex"
        >
          <!-- 遍历每个分组中的搜索项 -->
          <el-col
            v-for="(column, index) in group"
            :key="index"
            :span="column.search.span || 6"
            v-show="isExpanded ? true : groupIndex === 0"
          >
            <el-form-item :label="column.label + ':'" class="search-item">
              <!-- 输入框 -->
              <el-input
                v-if="column.search && column.search.type === 'input'"
                v-model="searchForm[column.prop]"
                :placeholder="
                  column.search.placeholder || `请输入${column.label}`
                "
                clearable
                class="search-input"
              ></el-input>

              <!-- 下拉选择 -->
              <el-select
                v-else-if="column.search && column.search.type === 'select'"
                v-model="searchForm[column.prop]"
                :placeholder="
                  column.search.placeholder || `请选择${column.label}`
                "
                clearable
                :loading="column.search.loading"
                :multiple="column.search.multiple"
                class="search-input"
              >
                <el-option
                  v-for="option in column.search.options"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                ></el-option>
              </el-select>

              <!-- 日期选择 -->
              <el-date-picker
                v-else-if="
                  column.search && (
                  column.search.type === 'date' ||
                  column.search.type === 'daterange' ||
                  column.search.type === 'datetime' ||
                  column.search.type === 'datetimerange')
                "
                v-model="searchForm[column.prop]"
                :type="column.search.dateType || column.search.type"
                :placeholder="
                  column.search.placeholder ||
                  (column.search.type.includes('range')
                    ? `请选择${column.label}范围`
                    : `请选择${column.label}`)
                "
                :value-format="
                  column.search.valueFormat ||
                  (column.search.type.includes('time')
                    ? 'yyyy-MM-dd HH:mm:ss'
                    : 'yyyy-MM-dd')
                "
                :default-time="
                  column.search.defaultTime || ['00:00:00', '23:59:59']
                "
                :start-placeholder="
                  column.search.startPlaceholder || '开始日期'
                "
                :end-placeholder="column.search.endPlaceholder || '结束日期'"
                :range-separator="column.search.rangeSeparator || '-'"
                clearable
                class="search-input"
              ></el-date-picker>

              <!-- 时间选择 -->
              <el-time-picker
                v-else-if="column.search && column.search.type === 'time'"
                v-model="searchForm[column.prop]"
                :placeholder="
                  column.search.placeholder || `请选择${column.label}`
                "
                value-format="HH:mm:ss"
                clearable
                class="search-input"
              ></el-time-picker>

              <!-- 复选框 -->
              <el-checkbox-group
                v-else-if="column.search && column.search.type === 'checkbox'"
                v-model="searchForm[column.prop]"
                class="search-input"
              >
                <el-checkbox
                  v-for="option in column.search.options"
                  :key="option.value"
                  :label="option.value"
                  >{{ option.label }}</el-checkbox
                >
              </el-checkbox-group>

              <!-- 单选框 -->
              <el-radio-group
                v-else-if="column.search && column.search.type === 'radio'"
                v-model="searchForm[column.prop]"
                class="search-input"
              >
                <el-radio
                  v-for="option in column.search.options"
                  :key="option.value"
                  :label="option.value"
                  >{{ option.label }}</el-radio
                >
              </el-radio-group>

              <!-- 其他类型 -->
              <span v-else>不支持的表单类型</span>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 查询按钮 -->
        <el-form-item>
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="margin-bottom: 0; background: #fff"
              @click="onSearch"
            >
              筛选
            </el-button>
            <!-- 自定义插槽中间 -->
            <slot name="search-actions-center"></slot>
            <span class="reset" @click="onReset"> 重置筛选条件 </span>
            <!-- 自定义插槽 -->
            <slot name="search-actions"></slot>
            <!-- 展开/收缩按钮 -->
            <div class="expand" @click="toggleExpand">
              <span>
                {{ isExpanded ? "收起" : "展开" }}
                <i
                  :class="
                    isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                  "
                ></i
              ></span>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div
      style="
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      "
    >
      <!-- 全选复选框 -->
      <div class="left" style="display: flex; align-items: center">
        <div class="custom-check" style="margin: 0 11px">
          <el-checkbox
            v-model="isAllSelected"
            :indeterminate="isIndeterminate"
            @change="handleSelectAll"
          >
            已选 {{ selectedRows.length }} 个
          </el-checkbox>
        </div>
        <slot name="left-area"></slot>
      </div>
      <div class="right">
        <!-- 列设置图标 -->
        <i
          class="el-icon-s-operation"
          style="cursor: pointer"
          @click="drawerVisible = true"
        ></i>
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      ref="table"
      :data="tableData"
      :key="tableKey"
      size="mini"
      style="width: 100%"
      :row-key="rowKey"
      :height="tableOpt.tableHeight || 'auto'"
      :border="tableOpt.tableBorder || false"
      v-loading="loading"
      @sort-change="onSortChange"
      @selection-change="handleSelectionChange"
      :cell-style="cellStyle"
      @row-click="rowClick"
    >
      <!-- 多选列 -->
      <el-table-column
        type="selection"
        width="55"
        fixed="left"
      ></el-table-column>

      <!-- 数据列 -->
      <el-table-column
        v-for="(column, index) in orderedTableColumns"
        :key="index"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :min-width="column.minWidth"
        :fixed="column.fixed"
        :sortable="column.sortable"
        :align="column.align || 'left'"
        :header-align="column.headerAlign || 'left'"
      >
        <!-- 自定义列内容 -->
        <template v-if="column.slot" v-slot="{ row }">
          <slot :name="column.slot" :row="row"></slot>
        </template>
        <!-- 格式化数据 -->
        <template v-else-if="column.formatter" v-slot="{ row }">
          {{ column.formatter(row) }}
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column
        label="操作"
        width="150"
        fixed="right"
        align="center"
        header-align="center"
        v-if="hasActionColumn"
      >
        <template slot-scope="scope">
          <slot name="action" :row="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pages">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="tableOpt.pageSizes || [10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </div>

    <!-- 列设置弹窗 -->
    <el-drawer
      title="表格设置"
      size="700px"
      :visible.sync="drawerVisible"
      class="custom-table"
      @opened="onDrawerOpened"
      @close="onDrawerClose"
    >
      <div class="table-set">
        <el-table
          ref="columnTable"
          :data="tableOpt.tableColumns"
          border
          height="calc(100vh - 100px)"
          size="mini"
          row-key="prop"
        >
          <el-table-column
            prop="label"
            label="列名"
            align="left"
            header-align="left"
            style="cursor: pointer"
          >
            <template slot-scope="scope">
              <div style="cursor: pointer">
                <i
                  class="el-icon-rank"
                  style="color: #35b1ff; font-size: 16px"
                  color="#35b1ff"
                ></i>
                <span style="margin-left: 10px">{{ scope.row.label }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="hidden"
            label="列隐藏"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="{ row }">
              <el-checkbox
                v-model="row.hidden"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="searchHidden"
            label="搜索项隐藏"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="{ row }">
              <el-checkbox
                v-model="row.searchHidden"
                @change="changeSearch(row)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="width"
            label="列宽"
            width="200"
            align="center"
            header-align="center"
          >
            <template slot-scope="{ row }">
              <el-input-number
                v-model="row.width"
                :min="50"
                :max="500"
                size="mini"
                :disabled="row.hidden"
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getDics } from "@/api/chain/companywaybill";
import { getByRoute, saveOrUpdate } from "@/api/chain/companycustompage";
import Sortable from "sortablejs";
export default {
  name: "CustomTable",
  props: {
    rowKey: {
      type: String,
      default: "id",
    },
    tableOpt: {
      type: Object,
      default: () => ({}),
    },
    fetchData: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      tableKey:"",
      searchForm: {
        status: ["2", "3", "4", "11", "12", "21", "22"],
      },
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      drawerVisible: false,
      isExpanded: false, // 是否展开
      selectedRows: [], // 选中的行
      isAllSelected: false, // 是否全选
      isIndeterminate: false, // 是否部分选中
      columnSettings: {}, // 用于存储列设置
      curRowKey: "",
    };
  },
  computed: {
    // 将搜索项按 span 总和不超过 24 的规则分组
    groupedSearchColumns() {
      const groups = [];
      let currentGroup = [];
      let currentSpanSum = 0;

      this.orderedSearchColumns.forEach((column) => {
        const span = (column.search && column.search.span) || 6; // 默认 span 为 6
        if (currentSpanSum + span > 24) {
          // 如果当前组的 span 总和超过 24，开始新分组
          groups.push(currentGroup);
          currentGroup = [column];
          currentSpanSum = span;
        } else {
          // 否则加入当前组
          currentGroup.push(column);
          currentSpanSum += span;
        }
      });

      // 添加最后一组
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }

      return groups;
    },
    // 根据搜索项排序规则动态计算显示的搜索项
    orderedSearchColumns() {
      const searchColumns = this.tableOpt.tableColumns.filter(
        (column) => column.search && !column.searchHidden
      );
      if (this.tableOpt.searchOrder) {
        return searchColumns.sort((a, b) => {
          const indexA = this.tableOpt.searchOrder.indexOf(a.prop);
          const indexB = this.tableOpt.searchOrder.indexOf(b.prop);

          // 如果找不到，则返回一个较大的值（确保排在后面）
          const orderA = indexA === -1 ? Infinity : indexA;
          const orderB = indexB === -1 ? Infinity : indexB;

          return orderA - orderB;
        });
      }
      return searchColumns;
    },
    // 根据表格列排序规则动态计算显示的表格列
    orderedTableColumns() {
      let columns = this.tableOpt.tableColumns;
      
      // 先过滤掉隐藏的列
      columns = columns.filter(column => !column.hidden);
      
      // 再根据排序规则排序
      if (this.tableOpt.columnOrder) {
        return columns.sort((a, b) => {
          const indexA = this.tableOpt.columnOrder.indexOf(a.prop);
          const indexB = this.tableOpt.columnOrder.indexOf(b.prop);

          // 如果找不到，则返回一个较大的值（确保排在后面）
          const orderA = indexA === -1 ? Infinity : indexA;
          const orderB = indexB === -1 ? Infinity : indexB;

          return orderA - orderB;
        });
      }
      return columns;
    },
    // 判断是否有操作列
    hasActionColumn() {
      return this.$scopedSlots.action;
    },
  },
  mounted() {
    this.loadColumnSettings(); // 加载列设置
    this.loadTableData();
    this.loadDictionaryData();
  },
  methods: {
    cellStyle(val) {
      if (
        this.tableOpt.rowClickKey &&
        val.row[this.tableOpt.rowClickKey] == this.curRowKey
      ) {
        return {
          background: "#e9f2ff",
          cursor: "pointer",
        };
      } else {
        return {
          cursor: "pointer",
        };
      }
    },
    rowClick(val) {
      if (this.tableOpt.rowClickKey) {
        this.curRowKey = val[this.tableOpt.rowClickKey];
      }
    },
    onDrawerOpened() {
      this.$nextTick(() => {
        this.initSortable(); // 在 drawer 打开后初始化 Sortable
      });
    },
    // 初始化 Sortable.js
    initSortable() {
      const table = this.$refs.columnTable.$el.querySelector(
        ".el-table__body-wrapper tbody"
      );

      Sortable.create(table, {
        animation: 150,
        ghostClass: "sortable-ghost",
        onEnd: (evt) => {
          const { oldIndex, newIndex } = evt;

          // 1. 直接操作原始数组（包括隐藏列）
          const movedItem = this.tableOpt.tableColumns.splice(oldIndex, 1)[0];
          this.tableOpt.tableColumns.splice(newIndex, 0, movedItem);

          // 2. 更新 columnOrder 为当前所有列的 prop 顺序（包括隐藏列）
          var i = 1
          this.tableOpt.columnOrder = this.tableOpt.tableColumns.map((col) => {
            i = i + 10;
            col.order = i;
            return col.prop
          });

          // 注意：不再立即保存，改为关闭弹窗时统一保存
        },
      });
    },
    // 加载列设置
    async loadColumnSettings() {
      try {
        const response = await getByRoute({ route: "companywaybill2" });
        if (response.data.data && response.data.data.pageTableOption) {
          const savedSettings = JSON.parse(response.data.data.pageTableOption);
          
          // 遍历保存的设置，更新现有的 tableColumns
          this.tableOpt.tableColumns.forEach(column => {
            const savedColumn = savedSettings[column.prop];
            if (savedColumn) {
              // 使用 Vue.set 确保属性是响应式的
              this.$set(column, 'hidden', savedColumn.hide || false);
              this.$set(column, 'searchHidden', !savedColumn.search);
              this.$set(column, 'width', savedColumn.width || column.width);
              this.$set(column, 'order', savedColumn.order || 9999);
              
              // 如果搜索被启用但当前列没有搜索配置，添加默认搜索配置
              if (savedColumn.search && !column.search) {
                this.$set(column, 'search', {
                  type: "input",
                  placeholder: "请输入" + column.label,
                });
              }
            }
          });
          
          // 根据 order 字段排序生成 columnOrder
          this.tableOpt.columnOrder = this.tableOpt.tableColumns
            .sort((a, b) => (a.order || 9999) - (b.order || 9999))
            .map(col => col.prop);
        }
      } catch (error) {
        console.error("加载列设置失败:", error);
        // 如果加载失败，使用默认设置
      }
    },
    // 保存列设置到数据库
    async saveColumnSettings() {
      try {
        // 转换数据结构：将组件的数组格式转换为接口要求的对象格式
        const pageTableOption = {};
        
        this.tableOpt.tableColumns.forEach(column => {
          // 创建列配置对象，保留原有属性并添加新的配置
          const columnConfig = {
            ...column, // 保留所有原有属性
            hide: column.hidden || false,
            search: !column.searchHidden,
            order: column.order || 9999
          };
          
          // 移除组件内部使用的属性，避免保存到数据库
          delete columnConfig.hidden;
          delete columnConfig.searchHidden;
          
          pageTableOption[column.prop] = columnConfig;
        });
        
        const requestData = {
          pageRoute: "companywaybill2",
          pageTableOption: JSON.stringify(pageTableOption)
        };
        
        await saveOrUpdate(requestData);
        this.tableKey = Date.now();
        this.$message.success("列设置保存成功");
      } catch (error) {
        console.error("保存列设置失败:", error);
        this.$message.error("保存列设置失败，请稍后重试");
      }
    },
    changeSearch(row) {
      if (!row.searchHidden) {
        row.search = {
          type: "input", // 搜索项类型
          placeholder: "请输入" + row.label, // 占位符
        };
      }
    },
    // 加载表格数据
    async loadTableData() {
      this.loading = true;
      const params = {
        ...this.searchForm,
        current: this.currentPage,
        size: this.pageSize,
      };
      // 处理多选值（逗号分隔）
      for (const key in params) {
        if (Array.isArray(params[key])) {
          if (
            this.tableOpt.tableColumns.some(
              (v) => v.prop == key && v.search && v.search.splitSymbl
            )
          ) {
            params[key] = params[key].join(
              this.tableOpt.tableColumns.find((v) => v.prop == key).search
                .splitSymbl
            );
          }
          // 将数组转换为逗号分隔的字符串
        }
      }
      try {
        const { data, total } = await this.fetchData(params);
        this.tableData = data;
        this.total = total;
      } catch (error) {
        console.error("Failed to load table data:", error);
      } finally {
        this.loading = false;
      }
    },
    // 加载字典数据
    async loadDictionaryData() {
      const promises = this.tableOpt.tableColumns
        .filter((column) => column.search && column.search.dicUrl)
        .map(async (column) => {
          column.search.loading = true;
          try {
            const res = await getDics(column.search.dicUrl);
            this.$set(
              column.search,
              "options",
              column.search.dicFormatter(res.data)
            );
          } catch (error) {
            console.error(
              `Failed to load dictionary data for ${column.prop}:`,
              error
            );
            this.$message.error(
              `加载 ${column.label} 的字典数据失败，请稍后重试`
            );
          } finally {
            column.search.loading = false;
          }
        });

      await Promise.all(promises);
    },
    // 查询
    onSearch() {
      this.currentPage = 1;
      this.loadTableData();
    },
    // 重置
    onReset() {
      this.searchForm = {
        status: ["2", "3", "4", "11", "12", "21", "22"],
      };
      this.loadTableData();
    },
    // 分页大小变化
    handleSizeChange(size) {
      this.pageSize = size;
      this.loadTableData();
    },
    // 当前页变化
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadTableData();
    },
    // 排序变化
    onSortChange({ column, prop, order }) {
      console.log("Sort by:", prop, order);
      // 可以在这里处理排序逻辑
    },
    // 列设置确认
    onColumnSettingConfirm() {
      this.drawerVisible = false;
      // 可以在这里保存列设置到本地存储或其他地方
    },
    // 切换展开/收缩状态
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      this.$emit("expandChange", this.isExpanded);
    },
    // 处理多选
    handleSelectionChange(rows) {
      this.selectedRows = rows;
      this.$emit("handleSelectionChange", rows);
      this.isIndeterminate =
        rows.length > 0 && rows.length < this.tableData.length;
      this.isAllSelected = rows.length === this.tableData.length;
    },
    // 处理全选
    handleSelectAll(val) {
      if (val) {
        this.$refs.table.toggleAllSelection(); // 全选
      } else {
        this.$refs.table.clearSelection(); // 取消全选
      }
    },
    onDrawerClose() {
      this.saveColumnSettings();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/newPage.scss";
.demo-form-inline {
  margin-bottom: 20px;
}

/* 搜索项样式 */
.search-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px; /* 增加间距 */
}

/deep/.search-item  .el-form-item__label {
  width: 120px; /* 固定 label 宽度 */
  flex-shrink: 0; /* 防止 label 被压缩 */
  text-align: right;
  padding-right: 10px;
}

.search-item /deep/ .el-form-item__content {
  flex-grow: 1; /* 输入框/选择框自适应宽度 */
  min-width: 0; /* 防止内容溢出 */
}

/* 输入框/选择框样式 */
.search-input {
  width: 100%; /* 输入框/选择框占满剩余空间 */
}
.pages {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.headerContent {
  margin-left: 110px !important;
}
.search {
  background: #f5f7fa;
  padding-top: 16px;
  padding-right: 16px;
}
/* 抽屉底部按钮 */
.drawer-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
/deep/.custom-label {
  .el-form-item__label {
    line-height: 17px !important;
    white-space: pre-wrap;
  }
}
.table-set {
  padding: 0 32px;
}
.custom-table {
  /deep/.el-drawer__header {
    padding: 11px 20px;
    border-bottom: 1px solid #ededf0;
  }
}
/* 拖拽时的占位符样式 */
.sortable-ghost {
  opacity: 0.5;
  background: #35b1ff;
}
</style>
